import type {
  PlotDataAttribution,
  PlotDataSource,
  PlotReqConfig,
} from "types/dashboard.types"

export const OPEN_METEO_ATTRIBUTION: PlotDataAttribution = "open-meteo"

export const linePlotDefBase: {
  draggable: boolean
  downloadable: boolean
  dataSource: PlotDataSource
  reqConfig: Partial<PlotReqConfig>
} = {
  draggable: true,
  downloadable: true,
  dataSource: { entity: "device", resolver: "self", service: "telemetry" },
  reqConfig: {
    aggregate_n: 180,
    aggregate_use_original_time: true,
    fetchQualitySummary: true,
    allowRawData: true,
    fetchFieldMetadata: true,
  },
}

export const scatterPlotDefBase: {
  draggable: boolean
  downloadable: boolean
  dataSource: PlotDataSource
  reqConfig: Partial<PlotReqConfig>
} = linePlotDefBase

export const singleStatPlotDefBase: {
  draggable: boolean
  downloadable: boolean
  dataSource: PlotDataSource
  reqConfig: Partial<PlotReqConfig>
} = {
  draggable: true,
  downloadable: false,
  dataSource: { entity: "device", resolver: "self", service: "telemetry" },
  reqConfig: {},
}

export const tableStatPlotDefBase: {
  draggable: boolean
  downloadable: boolean
  dataSource: PlotDataSource
  reqConfig: Partial<PlotReqConfig>
} = {
  draggable: true,
  downloadable: false,
  dataSource: { entity: "device", resolver: "self", service: "telemetry" },
  reqConfig: {},
}

export const mapPlotDefBase: {
  draggable: boolean
  downloadable: boolean
  dataSource: PlotDataSource
  reqConfig: Partial<PlotReqConfig>
} = {
  draggable: true,
  downloadable: false,
  dataSource: { entity: "device", resolver: "self", service: "telemetry" },
  reqConfig: {},
}
